module.exports = __webpack_public_path__ + "img/15b4d0c.jpg";